export default {
      id: "ic-misc-print-usage",
      viewBox: "0 0 26 26",
      url: "../dist/images/" + "sprite.svg#ic-misc-print-usage",
      toString: function () {
        return this.url;
      }
    }